'use client'

import { useEffect, useRef } from 'react'
import { useAuthSession } from '@/hooks/useAuthActions'
import { useUserStore } from '@/hooks/useUser'
import { Toaster, useLocalToaster } from '@/components/ui/toaster'

interface AuthProviderProps {
	children: React.ReactNode
}

export function AuthProvider({ children }: Readonly<AuthProviderProps>) {
	const { isInitialized } = useAuthSession()
	const { items, show, dismiss } = useLocalToaster()
	const { forcedLogoutToastPending, forcedLogoutToastToken, acknowledgeForcedLogoutNotice } = useUserStore()
	const lastShownToken = useRef<number | null>(null)

	useEffect(() => {
		if (!isInitialized) return
		if (!forcedLogoutToastPending) {
			if (forcedLogoutToastToken === null) {
				lastShownToken.current = null
			}
			return
		}
		if (forcedLogoutToastToken === null) return
		if (lastShownToken.current === forcedLogoutToastToken) return
		lastShownToken.current = forcedLogoutToastToken
		show({
			title: 'Acesso negado',
			description: 'Não foi possível validar seu usuário. Tente novamente e/ou contate o suporte.',
			variant: 'info',
			timeoutMs: 9000,
		})
		acknowledgeForcedLogoutNotice()
	}, [isInitialized, forcedLogoutToastPending, forcedLogoutToastToken, show, acknowledgeForcedLogoutNotice])

	return (
		<>
			{children}
			<Toaster items={items} onDismiss={dismiss} />
		</>
	)
}
